import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

export const GROUP_MANUAL_MEMBERSHIP_SYNC_RESOURCE = "group-manual-membership" as const;
export const GROUP_MANUAL_MEMBERSHIP_SYNC_API_PATH = `/v1/${GROUP_MANUAL_MEMBERSHIP_SYNC_RESOURCE}` as const;

export type GroupManualMembershipSyncBody =
  paths[typeof GROUP_MANUAL_MEMBERSHIP_SYNC_API_PATH]["put"]["requestBody"]["content"]["application/json"];
export type GroupManualMembershipSyncResponse =
  paths[typeof GROUP_MANUAL_MEMBERSHIP_SYNC_API_PATH]["put"]["responses"][200]["content"]["application/json"];

export const useGroupManualMembershipSyncMutation = (): UseMutationResult<
  GroupManualMembershipSyncResponse,
  Error,
  GroupManualMembershipSyncBody
> => {
  const queryClient = useQueryClient();

  return useMutation<GroupManualMembershipSyncResponse, Error, GroupManualMembershipSyncBody>({
    mutationFn: async (payload: GroupManualMembershipSyncBody) => {
      const response = await alphartisApiAxios.put<GroupManualMembershipSyncResponse>(
        GROUP_MANUAL_MEMBERSHIP_SYNC_API_PATH,
        payload,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GROUP_MANUAL_MEMBERSHIP_SYNC_RESOURCE] });
    },
  });
};
